export const getTimeResolutionOptions = ({ filters }: any) => {
  if (filters?.find((f: any) => f.id === 'Formation Period'))
    return filters?.find((f: any) => f.id === 'Formation Period')?.options;
  if (filters?.find((f: any) => f.id === 'Time Resolution'))
    return filters?.find((f: any) => f.id === 'Time Resolution')?.options;
};
